import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Find input elements by their name attributes
    this.dfnInput = this.element.querySelector(
      'input[name*="net_financial_liabilities"]',
    );
    this.ebitdaInput = this.element.querySelector('input[name*="ebitda"]');
    this.equityInput = this.element.querySelector('input[name*="equity"]');
    this.levierInput = this.element.querySelector('input[name*="levier"]');
    this.gearingInput = this.element.querySelector('input[name*="gearing"]');

    // Set up event listeners if all elements are found
    if (
      this.dfnInput &&
      this.ebitdaInput &&
      this.equityInput &&
      this.levierInput &&
      this.gearingInput
    ) {
      [this.dfnInput, this.ebitdaInput, this.equityInput].forEach((input) => {
        input.addEventListener("input", () => this.calculate());
        input.addEventListener("change", () => this.calculate());
      });

      // Run initial calculation
      this.calculate();
    }
  }

  calculate() {
    // Get numeric values
    const dfn = this.getNumericValue(this.dfnInput);
    const ebitda = this.getNumericValue(this.ebitdaInput);
    const equity = this.getNumericValue(this.equityInput);

    // Calculate Levier (DFN/EBITDA)
    let levierValue = "";
    if (dfn !== null && ebitda !== null && ebitda !== 0) {
      levierValue = (dfn / ebitda).toFixed(2);
    }

    // Calculate Gearing (DFN/Equity)
    let gearingValue = "";
    if (dfn !== null && equity !== null && equity !== 0) {
      gearingValue = (dfn / equity).toFixed(2);
    }

    // Update the calculated fields
    if (this.levierInput) {
      this.levierInput.value = levierValue;
    }
    if (this.gearingInput) {
      this.gearingInput.value = gearingValue;
    }
  }

  getNumericValue(element) {
    if (!element || !element.value) return null;

    const value = element.value.toString().trim();
    if (value === "") return null;

    const parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed;
  }
}
